<template>
  <div class="grid fc ac" @click="go($props.goUrl)">
    <el-image :src="$props.img" class="img" fit="contain">
      <div slot="error" class="fr ac jc fz32">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <div class="mt10">{{ $props.label }}</div>
  </div>
</template>

<script>
export default {
  name: "grid",
  props: {
    goUrl: String,
    permission_id: Number,
    label: String,
    img: String
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
.grid {
  width: 115px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;

  .img {
    width: 50px;
    height: 50px;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/grid.vue